// Cart related
export const CART_UUID_STORAGE_KEY: string = 'cart.uuid.' + import.meta.env.VITE_APP_ENV_NAME